<script>
    import { UserStore } from '../stores/UserStore.svelte.js';
    import LyContent from '../layouts/components/LyContent.svelte';
    import LyHeader from '../layouts/components/LyHeader.svelte';
    import LySection from '../layouts/components/LySection.svelte';
    import LyP from '../layouts/components/LyP.svelte';
    import LyGrid3 from '../layouts/components/LyGrid3.svelte';
    import LyHeadline from '../layouts/components/LyHeadline.svelte';
    import LyButtons from '../layouts/forms/LyButtons.svelte';
    import LyButton from '../layouts/forms/LyButton.svelte';
    import asanaLogo from '../../assets/asana.svg';
    import office365Logo from '../../assets/office365.svg';
    import easybillLogo from '../../assets/easybill.svg';
    import hrworksLogo from '../../assets/hrworks.svg';
    import LyImg from '../layouts/components/LyImg.svelte';
    import * as Icons from 'lucide-svelte';
    import LyButtonLine from '../layouts/forms/LyButtonLine.svelte';

    let isBilling = $state(UserStore.hasGroup('BILLING'));
</script>

<LyContent wrapper={true}>
    <LyHeader>
        <LyHeadline icon={Icons.Home}>
            Hallo {UserStore.nickName || UserStore.firstName || 'Du'}!
        </LyHeadline>
    </LyHeader>

    <LySection tag="div">
        <LyP>
            Herzlich willkommen in den DWC-Tools, unserer zentralen Anlaufstelle, in der Du alles findest, was Du für
            Deine <strong>tägliche Arbeit</strong> benötigst.
        </LyP>
    </LySection>
</LyContent>

<LyGrid3 wrapper={true} mt={true}>
    <LyContent tag="article" addClass="flex h-full flex-col">
        <LyHeader>
            <LyImg src={asanaLogo} alt="Asana-Logo" mt={true} />
        </LyHeader>
        <LyP mt={true} center={true}>
            Unser <strong>Projektmanagement-Tool</strong> nach dem Kanban-Prinzip zum Anlegen, Überwachen und Zuteilen von
            Aufgaben im Rahmen von Kampagnen und Projekten.
        </LyP>
        <div class="mt-auto">
            <LyButtons tag="p" mt={true} center={true}>
                <LyButton type="link" label="Zu Asana" href="https://app.asana.com/" target="_blank" />
            </LyButtons>
        </div>
    </LyContent>

    <LyContent tag="article" addClass="flex h-full flex-col">
        <LyHeader>
            <LyImg src={office365Logo} alt="Office 365" mt={true} />
        </LyHeader>
        <LyP mt={true} center={true}>
            Unsere <strong>Produktivitätstools</strong> bestehend aus MS Office (Outlook, Excel, Word, PowerPoint), Teams
            als zentraler Kommunikationskanal und OneDrive zur Dokumentenablage.
        </LyP>
        <div class="mt-auto">
            <LyButtons tag="p" mt={true} center={true}>
                <LyButton type="link" label="Zu Office 365" href="https://office.com/" target="_blank" />
            </LyButtons>
        </div>
    </LyContent>

    {#if isBilling}
        <LyContent tag="article" addClass="flex h-full flex-col">
            <LyHeader>
                <LyImg src={easybillLogo} alt="easybill" mt={true} />
            </LyHeader>
            <LyP mt={true} center={true}>
                Unser <strong>kommerzielles Tool</strong> für die Erstellung und Kalkulation von Angeboten, sowie das Schreiben
                von Lieferscheinen und Rechnungen.
            </LyP>
            <div class="mt-auto">
                <LyButtons tag="p" mt={true} center={true}>
                    <LyButton
                        type="link"
                        small={true}
                        label="DWC"
                        color="dwc"
                        href="https://c170897.easybill.de/"
                        target="_blank" />
                    <LyButton
                        type="link"
                        small={true}
                        label="TCF"
                        color="tcf"
                        href="https://c602848.easybill.de/"
                        target="_blank" />
                    <LyButton
                        type="link"
                        small={true}
                        label="Velti"
                        color="velti"
                        href="https://velti.easybill.de/"
                        target="_blank" />
                </LyButtons>
            </div>
        </LyContent>
    {/if}

    <LyContent tag="article" addClass="flex h-full flex-col">
        <LyHeader>
            <LyImg src={hrworksLogo} alt="HRworks" mt={true} />
        </LyHeader>
        <LyP mt={true} center={true}>
            Unser <strong>Personal-Tool für die Zeitwirtschaft</strong> (z.B. Beantragung von Urlaub oder Home Office), Reisemanagement
            oder Gehaltsdokumente.
        </LyP>
        <div class="mt-auto">
            <LyButtons tag="p" mt={true} center={true}>
                <LyButton
                    type="link"
                    label="Zu HRworks"
                    href="https://login.hrworks.de/?companyId=465baa07"
                    target="_blank" />
            </LyButtons>
        </div>
    </LyContent>
</LyGrid3>

<LyButtonLine tag="aside" mt={true}>
    <LyButton
        label="Abmelden"
        color={true}
        disabled={UserStore.waiting}
        onclick={() => UserStore.doLogout()}
        ask="Wirklich abmelden?" />
</LyButtonLine>
